<template>
  <div class="diagnose-help-tab w-100">
    <div class="ap-title ap-title__main px-3 pt-3 pb-2">
      <span>{{ $tc('global.diagnosis') }}</span>
    </div>
    <div class="px-3">
      <shortcuts-and-voice-commands-table :table-data="diagnoseShortcuts" />
    </div>
  </div>
</template>

<script>
import ShortcutsAndVoiceCommandsTable from '@/components/help/shortcutsAndVoiceCommands/ShortcutsAndVoiceCommandsTable'

export default {
    name: 'DiagnoseHelpTab',
    components: {
        ShortcutsAndVoiceCommandsTable
    },
    data() {
        return {
            diagnoseShortcuts: [
                {
                    tableTitle: this.$tc('component.shortcutsModal.labels.title.diagnosisGridTitle'),
                    tableElements: [
                        {
                            action: this.$tc('component.shortcutsModal.labels.action.patientsManagement'),
                            shortcuts: [
                                { key: 'F10' }
                            ],
                            voiceCommand: this.$tc('component.shortcutsModal.labels.voice.patientsManagement')
                        },
                        {
                            action: this.$tc('component.shortcutsModal.labels.action.openCase'),
                            shortcuts: [
                                { key: 'Ctrl' },
                                { key: 'far fa-level-down', icon: true }
                            ],
                            voiceCommand: this.$tc('component.shortcutsModal.labels.voice.openCase')
                        },
                        {
                            action: this.$tc('component.shortcutsModal.labels.action.batchActions'),
                            shortcuts: [
                                { key: 'Alt' },
                                { key: 'B' }
                            ],
                            voiceCommand: this.$tc('component.shortcutsModal.labels.voice.batchActions')
                        }
                    ]
                },
                {
                    tableTitle: this.$tc('component.shortcutsModal.labels.title.diagnosisFormTitle'),
                    tableElements: [
                        {
                            action: this.$t('component.shortcutsModal.labels.action.pathologicalReport'),
                            shortcuts: [
                                { key: 'Ctrl' },
                                { key: 'Shift' },
                                { key: 'V' }
                            ],
                            voiceCommand: this.$t('component.shortcutsModal.labels.voice.pathologicalReport')
                        },
                        {
                            action: this.$tc('component.shortcutsModal.labels.action.saveDiagnosis'),
                            shortcuts: [
                                { key: 'Alt' },
                                { key: 'S' }
                            ],
                            voiceCommand: this.$tc('component.shortcutsModal.labels.voice.saveDiagnosis')
                        },
                        {
                            action: this.$tc('component.shortcutsModal.labels.action.informAndValidateDiagnosis'),
                            shortcuts: [
                                { key: 'Ctrl' },
                                { key: 'far fa-level-down', icon: true }
                            ],
                            voiceCommand: this.$tc('component.shortcutsModal.labels.voice.informAndValidateDiagnosis')
                        },
                        {
                            action: this.$tc('component.shortcutsModal.labels.action.informDiagnosis'),
                            shortcuts: [
                                { key: 'Alt' },
                                { key: 'I' }
                            ],
                            voiceCommand: this.$tc('component.shortcutsModal.labels.voice.informDiagnosis')
                        },
                        {
                            action: this.$tc('component.shortcutsModal.labels.action.validateDiagnosis'),
                            shortcuts: [
                                { key: 'Alt' },
                                { key: 'V' }
                            ],
                            voiceCommand: this.$tc('component.shortcutsModal.labels.voice.validateDiagnosis')
                        },
                        {
                            action: this.$t('component.shortcutsModal.labels.action.toggleSamplesPanel'),
                            shortcuts: [
                                { key: 'F2' }
                            ],
                            voiceCommand: this.$t('component.shortcutsModal.labels.voice.toggleSamplesPanel')
                        },
                        {
                            action: this.$t('component.shortcutsModal.labels.action.toggleCasePanel'),
                            shortcuts: [
                                { key: 'Alt' },
                                { key: 'F2' }
                            ],
                            voiceCommand: this.$t('component.shortcutsModal.labels.voice.toggleCasePanel')
                        },
                        {
                            action: this.$t('component.shortcutsModal.labels.action.toggleCaseSamplePanel'),
                            shortcuts: [
                                { key: 'Ctrl' },
                                { key: 'Alt' },
                                { key: 'F2' }
                            ],
                            voiceCommand: this.$t('component.shortcutsModal.labels.voice.toggleCaseSamplePanel')
                        },
                        {
                            action: this.$tc('component.shortcutsModal.labels.action.samplesSection'),
                            shortcuts: [
                                { key: 'Alt' },
                                { key: '1' }
                            ],
                            voiceCommand: this.$tc('component.shortcutsModal.labels.voice.sampleDiagnosisSection')
                        },
                        {
                            action: this.$tc('component.shortcutsModal.labels.action.macroSection'),
                            shortcuts: [
                                { key: 'Alt' },
                                { key: '2' }
                            ],
                            voiceCommand: this.$tc('component.shortcutsModal.labels.voice.macroDiagnosisSection')
                        },
                        {
                            action: this.$tc('component.shortcutsModal.labels.action.integralDiagnosisSection'),
                            shortcuts: [
                                { key: 'Alt' },
                                { key: '3' }
                            ],
                            voiceCommand: this.$tc('component.shortcutsModal.labels.voice.integralDiagnosisSection')
                        },
                        {
                            action: this.$tc('component.shortcutsModal.labels.action.complementariesSection'),
                            shortcuts: [
                                { key: 'Alt' },
                                { key: '4' }
                            ],
                            voiceCommand: this.$tc('component.shortcutsModal.labels.voice.complementariesSection')
                        }
                    ]
                },
                {
                    tableTitle: this.$tc('component.shortcutsModal.labels.title.diagnosisSamplesSectionTitle'),
                    tableElements: [
                        {
                            action: this.$tc('component.shortcutsModal.labels.action.macroscopyTab'),
                            shortcuts: [
                                { key: 'Ctrl' },
                                { key: '1' }
                            ],
                            voiceCommand: this.$tc('component.shortcutsModal.labels.voice.macroSection')
                        },
                        {
                            action: this.$tc('component.shortcutsModal.labels.action.microscopyTab'),
                            shortcuts: [
                                { key: 'Ctrl' },
                                { key: '2' }
                            ],
                            voiceCommand: this.$tc('component.shortcutsModal.labels.voice.microSection')
                        },
                        {
                            action: this.$tc('component.shortcutsModal.labels.action.evaluationTab'),
                            shortcuts: [
                                { key: 'Ctrl' },
                                { key: '3' }
                            ],
                            voiceCommand: this.$tc('component.shortcutsModal.labels.voice.evaluationSection')
                        },
                        {
                            action: this.$tc('component.shortcutsModal.labels.action.makingTab'),
                            shortcuts: [
                                { key: 'Ctrl' },
                                { key: '4' }
                            ],
                            voiceCommand: this.$tc('component.shortcutsModal.labels.voice.makingSection')
                        },
                        {
                            action: this.$tc('component.shortcutsModal.labels.action.diagnosisTab'),
                            shortcuts: [
                                { key: 'Ctrl' },
                                { key: '5' }
                            ],
                            voiceCommand: this.$tc('component.shortcutsModal.labels.voice.diagnosisSection')
                        },
                        {
                            action: this.$tc('component.shortcutsModal.labels.action.additionalReportTab'),
                            shortcuts: [
                                { key: 'Ctrl' },
                                { key: '6' }
                            ],
                            voiceCommand: this.$tc('component.shortcutsModal.labels.voice.additionalReportSection')
                        },
                        {
                            action: this.$tc('component.shortcutsModal.labels.action.codificationsTab'),
                            shortcuts: [
                                { key: 'Ctrl' },
                                { key: '7' }
                            ],
                            voiceCommand: this.$tc('component.shortcutsModal.labels.voice.codificationsSection')
                        },
                        {
                            action: this.$tc('component.shortcutsModal.labels.action.observationsTab'),
                            shortcuts: [
                                { key: 'Ctrl' },
                                { key: '8' }
                            ],
                            voiceCommand: this.$tc('component.shortcutsModal.labels.voice.observationsSection')
                        },
                        {
                            action: this.$tc('component.shortcutsModal.labels.action.sampleDetailsTab'),
                            shortcuts: [
                                { key: 'Ctrl' },
                                { key: '9' }
                            ],
                            voiceCommand: this.$tc('component.shortcutsModal.labels.voice.sampleDetailSection')
                        },
                        {
                            action: this.$t('component.shortcutsModal.labels.action.assaysLaboratory'),
                            shortcuts: [
                                { key: 'Alt' },
                                { key: 'A' }
                            ],
                            voiceCommand: this.$t('component.shortcutsModal.labels.voice.assays')
                        },
                        {
                            action: this.$t('component.shortcutsModal.labels.action.addCoding'),
                            shortcuts: [
                                { key: 'Ctrl' },
                                { key: '+' }
                            ],
                            voiceCommand: this.$t('component.shortcutsModal.labels.voice.addCoding')
                        }
                    ]
                },
                {
                    tableTitle: this.$t('component.shortcutsModal.labels.title.textTemplatesTitle'),
                    tableElements: [
                        {
                            action: this.$t('component.shortcutsModal.labels.action.textTemplates'),
                            shortcuts: [
                                { key: 'Alt' },
                                { key: 'T' }
                            ],
                            voiceCommand: this.$t('component.shortcutsModal.labels.voice.textTemplates')
                        },
                        {
                            action: this.$t('component.shortcutsModal.labels.action.showTemplate'),
                            shortcuts: [
                                { key: null }
                            ],
                            voiceCommand: this.$t('component.shortcutsModal.labels.voice.showTemplate')
                        },
                        {
                            action: this.$t('component.shortcutsModal.labels.action.nextField'),
                            shortcuts: [
                                { key: 'Ctrl' },
                                { key: 'far fa-arrow-right', icon: true }
                            ],
                            voiceCommand: this.$t('component.shortcutsModal.labels.voice.nextField')
                        },
                        {
                            action: this.$t('component.shortcutsModal.labels.action.previousField'),
                            shortcuts: [
                                { key: 'Ctrl' },
                                { key: 'far fa-arrow-left', icon: true }
                            ],
                            voiceCommand: this.$t('component.shortcutsModal.labels.voice.nextField')
                        },
                        {
                            action: this.$t('component.shortcutsModal.labels.action.addTemplate'),
                            shortcuts: [
                                { key: 'Ctrl' },
                                { key: 'far fa-level-down', icon: true }
                            ],
                            voiceCommand: this.$t('component.shortcutsModal.labels.voice.addTemplate')
                        }
                    ]
                }
            ]
        }
    }
}
</script>
